import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getCurSiteId } from "../lib/Common_funcs.js";
import { useAuth } from '../lib/StAuthGiver';
import Spinner from 'react-bootstrap/Spinner';
import StSiteCreatorModal from "./StSiteCreatorModal";
import {
  FiChevronDown, FiPlus, FiLogOut,
} from "react-icons/fi";

const WhichEnv = (process.env.REACT_APP_TURBO_ENV === undefined ? 'aws' : 'staging');
const Tdebug = (WhichEnv !== 'aws');

export const getMaxSites = () => {
  const ud = JSON.parse(localStorage.getItem("uDet"));
  const isActive = ud?.isActive;
  const maxS = ud?.planDetails?.numSites;
  return isActive === true ? maxS : 1;
};

export const StDashTopbar = () => {
  const { logOut, isLoading } = useAuth();
  const [sites, setSites] = useState([]);
  const [currentSiteIdx, setCurrentSiteIdx] = useState(
    parseInt(localStorage.getItem('curSiteIdx') || '0')
  );
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showSiteModal, setShowSiteModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const currentSites = JSON.parse(localStorage.getItem("sites")) || [];
    setSites(currentSites.length ? currentSites : []);
  }, []);

  const currentSite = sites[currentSiteIdx]?.siteName || "";

  const switchSite = (idx) => {
    setCurrentSiteIdx(idx);
    localStorage.setItem("curSiteIdx", idx.toString());
    localStorage.setItem("curSite", sites[idx].siteName);
    setDropdownOpen(false);
    Tdebug && console.log("Navigating to: /" + sites[idx].siteId + "/home");
    navigate("/" + sites[idx].siteId + "/home", { replace: true });
    navigate(0);
  };

  const handleSiteCreated = (newSiteId, newSiteName) => {
    const currentSites = JSON.parse(localStorage.getItem("sites")) || [];
    setSites(currentSites);
    const newIdx = currentSites.length - 1;
    setCurrentSiteIdx(newIdx);
    localStorage.setItem('curSiteIdx', newIdx);
  };

  return (
    <>
      <header className="app-topbar">
        <div className="topbar-left">
          <div className="topbar-breadcrumb">
            <span style={{ color: "var(--text-tertiary)" }}>Dashboard</span>
            <span className="topbar-breadcrumb-sep">/</span>
            <span style={{ fontWeight: 500, color: "var(--text-primary)" }}>{currentSite}</span>
          </div>
        </div>

        <div className="topbar-right">
          {/* Site switcher */}
          <div style={{ position: "relative" }}>
            <button
              className="btn-modern btn-modern-secondary"
              onClick={() => setDropdownOpen(!dropdownOpen)}
              onBlur={() => setTimeout(() => setDropdownOpen(false), 150)}
            >
              {currentSite || "My Sites"}
              <FiChevronDown size={12} />
            </button>

            {dropdownOpen && (
              <div style={{
                position: "absolute", top: "calc(100% + 6px)", right: 0,
                minWidth: "180px", background: "var(--bg-secondary)",
                border: "1px solid var(--border-color)", borderRadius: "var(--radius-md)",
                boxShadow: "var(--shadow-lg)", zIndex: 100, overflow: "hidden",
              }}>
                {sites.map((site, idx) => (
                  <button
                    key={site.siteId}
                    onMouseDown={() => switchSite(idx)}
                    style={{
                      display: "block", width: "100%", padding: "10px 14px",
                      textAlign: "left", border: "none", fontFamily: "inherit",
                      background: idx === currentSiteIdx ? "var(--accent-soft)" : "transparent",
                      color: idx === currentSiteIdx ? "var(--accent-primary)" : "var(--text-primary)",
                      fontSize: "13px", cursor: "pointer", transition: "background 100ms ease",
                    }}
                    onMouseEnter={(e) => { if (idx !== currentSiteIdx) e.currentTarget.style.background = "var(--bg-hover)"; }}
                    onMouseLeave={(e) => { if (idx !== currentSiteIdx) e.currentTarget.style.background = "transparent"; }}
                  >
                    {site.siteName}
                  </button>
                ))}
                <div style={{ borderTop: "1px solid var(--border-color)" }}>
                  <button
                    onMouseDown={() => { setDropdownOpen(false); setShowSiteModal(true); }}
                    style={{
                      display: "flex", alignItems: "center", gap: "6px",
                      width: "100%", padding: "10px 14px", textAlign: "left",
                      border: "none", background: "transparent", fontFamily: "inherit",
                      color: "var(--accent-primary)", fontSize: "13px",
                      fontWeight: 500, cursor: "pointer",
                    }}
                  >
                    <FiPlus size={14} />
                    Add new site
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Logout */}
          <button
            className="topbar-btn"
            onClick={logOut}
            title="Logout"
            style={{ color: "var(--error)" }}
          >
            {isLoading
              ? <Spinner animation="border" style={{ width: "14px", height: "14px", borderWidth: "2px" }} />
              : <FiLogOut size={16} />
            }
          </button>
        </div>
      </header>

      <StSiteCreatorModal
        show={showSiteModal}
        onHide={() => setShowSiteModal(false)}
        onSiteCreated={handleSiteCreated}
      />
    </>
  );
};

export default StDashTopbar;
